import { get, set } from '../../../../cache';
const UPSALE_SERVICE_TYPE_SHOWN = 'UPSALE_SERVICE_TYPE_SHOWN';
const keyGenerator = (orderId, type) => `${UPSALE_SERVICE_TYPE_SHOWN}_${type}_${orderId}`;
export const isUpsaleServiceTypeWasShown = (orderId, type) => get(keyGenerator(orderId, type), false, sessionStorage);
export const setUpsaleServiceTypeWasShown = (orderId, type) => set(keyGenerator(orderId, type), true, sessionStorage);
